<table class="standard-table" [class.column-width-limits]="useColumnWidthLimits()" [class.use-3-cols]="show3Columns()">
  <thead>
    <tr>
      <th>{{ nameColumnTitleTranslationKey | translate }}</th>
      <th>
        <span [class]="recipientType() != 'company' ? contactDetailIconClass() : ''"></span>
        {{ recipientType() === "company" ? ("shared.CompanyRegistrationId" | translate) : "" }}
      </th>

      @if (isStatus()) {
        <th translate>app.Status</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (recipientDetails of recipientsDetails(); track $index) {
      <tr>
        <td>{{ recipientDetails.name }}</td>
        <td class="white-space-nowrap">
          @switch (recipientType()) {
            @case ("email") {
              {{ recipientDetails.email }}
            }
            @case ("phone") {
              {{ "+" + recipientDetails.phoneCode + recipientDetails.phoneNumber | phoneFormatWithCode }}
            }
            @case ("company") {
              {{ recipientDetails.companyRegistrationId }}
            }
          }
          @if (recipientDetails.isSubscription) {
            {{ " (" + ("enrollment.Enrolled" | translate) + ")" }}
          }
        </td>

        @if (isStatus()) {
          <td>{{ recipientDetails.status }}</td>
        }
      </tr>
    }
  </tbody>
</table>
